import api from '@/js/services/api';

export default {

    deleteHistory(id) {
        return api().delete(`user/work-history/` + id + '/delete');
    },
}
